import { getWeekStart } from '@utils/dates'
import { DateTime, Interval } from 'luxon'
import { useMemo } from 'react'
import { useWeekDatesSearchParams } from './useWeekDatesSearchParams'

const getRange = (start: DateTime, end: DateTime) =>
  Interval.fromDateTimes(start, end)
    .splitBy({ day: 1 })
    .map((i) => i.start)

interface Options {
  weekStartsOn: 'sunday' | 'monday'
  zone?: string
}

export const useWeekDates = (
  { weekStartsOn, zone }: Options = { weekStartsOn: 'sunday' },
) => {
  const { start: startParam, set } = useWeekDatesSearchParams({
    zone,
    weekStartsOn,
  })

  return useMemo(() => {
    const start = getWeekStart(
      startParam ?? DateTime.local().setZone(zone),
      weekStartsOn,
    )

    const end = start.plus({ days: 6 }).endOf('day')

    return { start, end, range: getRange(start, end), set }
  }, [startParam, zone, weekStartsOn, set])
}
